import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const CurrentContentScorePage = lazy(
  () => import('~/features/content-enrichment/pages/current-content-score-page'),
);

/** Step 0 — Current Content Score page for the Google Ads enrichment funnel. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CurrentContentScorePage />
    </Suspense>
  ),
});
